import request from '@/utils/request'

// 查询线索接收列表
export function login(query) {
  return request({
    url: '/api/user/login',
    method: 'GET',
    params: query , //params修改为data
    headers: {} ,
  })
}

// 验证码获取
export function getSmsCodeReq(query) {
  return request({
    url: '/api/user/getSmsCodePc',
    method: 'GET',
    params: query , //params修改为data
  })
}
//验证码验证
export function verifySmsCodeReq(query) {
  return request({
    url: '/api/user/verifySmsCode',
    method: 'GET',
    params: query , //params修改为data
  })
}


//重置密码  
export function resetPwdReq(query) {
  return request({
    url: '/api/user/resetPwd',
    method: 'GET',
    params: query , //params修改为data
  })
}